import React from 'react';

export default function ListItem({ option, onDragStart, readOnly }) {
  if (!option) {
    return null;
  }

  return (
    <li
      draggable={!readOnly}
      onDragStart={onDragStart}
      className={`inline-flex min-w-[20rem] px-4 py-2 rounded-sm text-sm bg-white dark:bg-slate-800 shadow-lg border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-100${
        readOnly ? '' : ' cursor-pointer'
      }`}
    >
      <div className="flex w-full justify-between items-start">
        <div className="flex">
          <div>{option?.label}</div>
        </div>
      </div>
    </li>
  );
}
